/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Titles_DisplayInputs */

const en_settings_titles_display = /** @type {(inputs: Settings_Titles_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display`)
};

/**
* | output |
* | --- |
* | "Display" |
*
* @param {Settings_Titles_DisplayInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_titles_display = /** @type {((inputs?: Settings_Titles_DisplayInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Titles_DisplayInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_titles_display(inputs)
});